import React from 'react'
import { Search, ChevronRight, Menu } from 'lucide-react'
import { Divider } from '@mui/material'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { path } from '../Utils/ScreenPath';
import profileAvatar from '../assets/images/profileAvatar.png'



export default function Header({ HeadersPath, toggleSidebar }) {
    const GetUser = useSelector((state) => state?.GetUser?.GetUserData || {});
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate(path?.Profile);
    }

    return (
        <>
            <header className="bg-[#F6F7F9] p-4 flex justify-between items-center">
                <div className="flex items-center space-x-4">
                    <button onClick={toggleSidebar} className="md:hidden">
                        <Menu className="w-6 h-6" />
                    </button>
                    <div className=" commanTextClass hidden md:flex items-center space-x-2 ml-0">
                        <React.Fragment>
                            <span className="commanTextClass">{HeadersPath}</span>
                        </React.Fragment>
                    </div>
                </div>
                <div className="flex items-center space-x-4" onClick={handleLogoClick}>
                    <div className="flex items-center space-x-2">
                        <span className="commanTextClass text-end">{GetUser?.data?.userInfo?.first_name}</span>
                        {GetUser?.data?.userInfo?.image ? <img
                            src={GetUser?.data?.userInfo?.image}
                            alt="User profile"
                            className="w-10 h-10 rounded-full border-2 border-gray-300"
                        /> :
                            <img
                                src={profileAvatar}
                                alt="User profile"
                                className="w-10 h-10 rounded-full border-2 border-gray-300"
                            />}
                    </div>
                </div>
            </header>
            <Divider />
        </>
    )
}